import React from 'react';

type IconProps = React.SVGProps<SVGSVGElement>;

// eslint-disable-next-line import/no-anonymous-default-export
export default (props: IconProps) => (
  <svg
    width="18"
    height="20"
    viewBox="0 0 512 512"
    fill="currentColor"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <g>
      <g>
        <path
          d="M467.214,463.038L467.214,463.038V200.946h43.724v-88.349L256,17.615L1.063,112.597v88.349h43.724v262.092H0v31.347
			h44.786h65.463h291.503h65.463H512v-31.347H467.214z M32.41,169.601v-0.001v-35.229L256,51.066l223.59,83.305v35.229h-12.377
			H44.786H32.41z M370.405,463.038H141.596v-25.593h228.809V463.038z M370.405,406.099H141.596v-25.561h228.809V406.099z
			 M370.405,349.19H141.596v-25.562h228.809V349.19z M370.405,292.281h-0.001H141.596v-26.964h228.809V292.281z M435.867,463.038
			h-34.116v0V233.97H110.249v229.068H76.133V200.946h359.733V463.038z"
        />
      </g>
    </g>
  </svg>
);
